/**
 * Action to close mobile keyboard or remove focus from active input element
 * This is typically triggered on Enter key press in mobile web
 * @param props - Can contain an event object with keyboard event information
 */
export const closeMobileKeyboard = (props?: { event?: KeyboardEvent | React.KeyboardEvent }) => {
    const event = props?.event;
    // Only proceed if Enter key was pressed
    if (event) {
        const key = (event as KeyboardEvent).key || (event as React.KeyboardEvent).key;
        const keyCode = (event as KeyboardEvent).keyCode || (event as React.KeyboardEvent).keyCode;

        // Check if Enter key was pressed (key === 'Enter' or keyCode === 13)
        if (key !== 'Enter' && keyCode !== 13) {
            return; // Exit early if not Enter key
        }
    } else {
        // If no event is provided, don't proceed (safety check)
        return;
    }

    // Get the currently active/focused element
    const activeElement = document.activeElement as HTMLElement;

    // Check if the active element is an input, textarea, or contenteditable element
    if (
        activeElement &&
        (activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.isContentEditable)
    ) {
        // Remove focus from the element, which will close the mobile keyboard
        activeElement.blur();
    }

    // Also blur the window/document as a fallback
    if (typeof window !== 'undefined' && window.document) {
        window.document.body.focus();
    }
};
